// src/pages/gt3x/Schedule.jsx

const GOOGLE_ICAL_FEED_URL = "https://calendar.google.com/calendar/ical/race%40racevision.info/public/basic.ics"

// Für Google können wir einen schönen „Add to Google Calendar“-Link bauen,
// der den iCal-Link bereits als cid-Parameter übergibt:
const GOOGLE_CALENDAR_SUBSCRIBE_LINK =
    "https://calendar.google.com/calendar/u/0/r?cid=" +
    encodeURIComponent(GOOGLE_ICAL_FEED_URL);

export default function Schedule() {
    return (
        <div className="card overview-card-top">
            <h1>Schedule Special Xperience</h1>
            <p>Das ist der Race Schedule in der Racevision Special Xperience. <br/><br/>
            </p>

            {/* NEU: Kalender-Actions */}
            <div
                style={{
                    marginTop: "20px",
                    padding: "16px",
                    borderRadius: "10px",
                    background: "var(--panel-2, #1f2c29)",
                    border: "1px solid var(--accent-2, #0a3d35)",
                }}
            >
                <h2 style={{ marginTop: 0, marginBottom: "10px" }}>
                    <br/> Alle Termine in deinen Kalender übernehmen
                </h2>
                <p style={{ marginBottom: "12px", fontSize: "0.95rem", lineHeight: 1.5 }}>
                    Du kannst die komplette Season als Kalender abonnieren. Änderungen an Terminen werden beim Abo automatisch
                    synchronisiert.
                </p>

                <div
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "10px",
                        marginTop: "15px",
                    }}
                >
                    {/* Google Calendar */}
                    <a
                        href={GOOGLE_CALENDAR_SUBSCRIBE_LINK}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary"
                        style={{
                            padding: "8px 14px",
                            borderRadius: "999px",
                            textDecoration: "none",
                            fontSize: "0.9rem",
                            fontWeight: 600,
                            background: "var(--accent, #e4fe3c)",
                            color: "#000",
                        }}
                    >
                        + Add to Google Calendar
                    </a>

                    {/* Apple / iOS / andere via direkter iCal-Link */}
                    <a
                        href={GOOGLE_ICAL_FEED_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-ghost"
                        style={{
                            padding: "8px 14px",
                            borderRadius: "999px",
                            textDecoration: "none",
                            fontSize: "0.9rem",
                            fontWeight: 500,
                            border: "1px solid var(--accent, #e4fe3c)",
                        }}
                    >
                        + Subscribe via iCal (Apple & others)
                    </a>

                </div>
            </div>

            <div
                style={{
                    width: "100%",
                    maxWidth: "900px",     // ← Begrenzung, damit es nicht zu groß wird
                    margin: "25px auto 0",      // ← zentrieren
                }}
            >
                <img
                    src="/schedule/SpecialX_RaceSchedule_SeasonI_Reveal.png"
                    alt="SpecialX Schedule"
                    style={{
                        width: "100%",
                        height: "auto",
                        display: "block",
                        borderRadius: "10px",
                    }}
                />
            </div>
        </div>
    );
}
